import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import reportWebVitals from "./reportWebVitals";
import Register from "./components/register";
import Login from "./components/login";
import Home from "./components/home";
import Withdraw from "./components/dashboard/withdraw";
import ChangeWalletOwner from "./components/dashboard/ChangeWalletOwner";

import ChangeWallet from "./components/dashboard/ChangeWallet";
import ChangeWalletByOwner from "./components/dashboard/ChangeWalletByOwner";
import RecycleContractFunds from "./components/dashboard/RecycleContractFunds";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Home />} />
        <Route path="join" element={<Register />} />
        <Route path="login" element={<Login />} />
        <Route path="withdraw" element={<Withdraw />} />
        <Route path="wchange" element={<ChangeWallet />} />

        <Route path="holderfunds" element={<RecycleContractFunds />} />

        <Route path="changeowners" element={<ChangeWalletOwner />} />
        <Route path="wchangebyboss" element={<ChangeWalletByOwner />} />
        <Route path="*" element={<DashboardLayout />} />
      </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
